import { usersApi } from 'entities/users';

type PutProductLocalizationResponseDataType = {
  product_id: number | null;
};

const productLocalizationApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    updateProductLocalization: builder.mutation<PutProductLocalizationResponseDataType, any>({
      query: (body) => ({
        url: '/shop/admin/v1/localization/update-localization-by-id',
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const { useUpdateProductLocalizationMutation } = productLocalizationApi;
